<template>
  <div
    class="alert alert-light b-notification border-2 d-flex text-black"
    role="alert"
  >
    <b-icon
      icon="info-circle"
      class="flex-grow-0 pe-3"
    />
    <div class="font-condensed">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/colors';

.b-notification.alert.alert-light {
  background-color: $gray-100 !important;
  border: 0.125rem solid $gray-400 !important;
  padding: .75rem 1.25rem;
}
</style>
